export default "__VITE_ASSET__BUzIqhUC__"